module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hcm-std",
    staticStyle: {
      "background": "#FFF"
    },
    attrs: {
      "name": "hcm-std",
      "id": "hcm-std"
    }
  }, [_vm._m(0), _vm._v(" "), _c('menu-std', {
    attrs: {
      "togglePage": _vm.togglePage,
      "exButtonActive": _vm.exButtonActive,
      "exButtonGroupActive": _vm.exButtonGroupActive,
      "exCollapseActive": _vm.exCollapseActive,
      "exDropdownActive": _vm.exDropdownActive,
      "exCheckboxActive": _vm.exCheckboxActive,
      "exFileActive": _vm.exFileActive,
      "exInputActive": _vm.exInputActive,
      "exRadioActive": _vm.exRadioActive,
      "exSelectActive": _vm.exSelectActive,
      "exModalActive": _vm.exModalActive,
      "exTabActive": _vm.exTabActive
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "contents"
  }, [_c('exButton', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.exButtonActive),
      expression: "exButtonActive"
    }]
  }), _vm._v(" "), _c('exButtonGroup', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.exButtonGroupActive),
      expression: "exButtonGroupActive"
    }]
  }), _vm._v(" "), _c('exCollapse', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.exCollapseActive),
      expression: "exCollapseActive"
    }]
  }), _vm._v(" "), _c('exDropdown', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.exDropdownActive),
      expression: "exDropdownActive"
    }]
  }), _vm._v(" "), _c('exCheckbox', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.exCheckboxActive),
      expression: "exCheckboxActive"
    }]
  }), _vm._v(" "), _c('exFile', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.exFileActive),
      expression: "exFileActive"
    }]
  }), _vm._v(" "), _c('exInput', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.exInputActive),
      expression: "exInputActive"
    }]
  }), _vm._v(" "), _c('exRadio', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.exRadioActive),
      expression: "exRadioActive"
    }]
  }), _vm._v(" "), _c('exSelect', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.exSelectActive),
      expression: "exSelectActive"
    }]
  }), _vm._v(" "), _c('exModal', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.exModalActive),
      expression: "exModalActive"
    }]
  }), _vm._v(" "), _c('exTab', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.exTabActive),
      expression: "exTabActive"
    }]
  })], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title-bar"
  }, [_c('div', {
    staticClass: "title -heading"
  }, [_vm._v("UI KIT")]), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_c('div', {
    staticClass: "name"
  }, [_vm._v("Style Guide template")]), _vm._v(" "), _c('div', {
    staticClass: "for"
  }, [_vm._v("For Designer and Developer")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-78a774f0!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/styleGuide/component.vue
// module id = 3900
// module chunks = 1